import isEmpty from 'lodash/isEmpty'

export default elision

/** @ngInject */
function elision() {
    const VOWEL = ['a', 'e', 'i', 'o', 'u']
    return function (val) {
        if (isEmpty(val)) {
            return val
        }
        return VOWEL.indexOf(val[0]) > -1 ? `d'${val}` : `de ${val}`
    }
}



// WEBPACK FOOTER //
// ./src/services/filters/elision.js